import { defaultTo } from 'ramda';

import { IAuction } from '../../../../types/reducers/auction';
import { mapAuctionStrategy } from './mapAuctionStrategy';
import { mapPeriod } from '../mapPeriod';
import { mapAuctionConfigurations } from './mapAuctionConfigurations';
import { mapAuctionServiceCosts } from './mapAuctionServiceCosts';
import { IAuction as IAuctionSchema } from '../../../../repositories/billing-tariffs/entities/PublishTerms/Auction';
import { EServiceType } from '../../../../types/reducers/publishTerms';

export function mapAuction(auctionTerm?: IAuctionSchema | null): IAuction {
  const { auctionInfo, strategyInfo: rawStrategy, incompatibleServices, isAvailable } = auctionTerm || {};

  const {
    overServiceBet,
    overPackageBet,
    maximalBet,
    minimalBet,
    configurations: rawConfigurations,
    serviceCosts: rawServiceCosts,
  } = auctionInfo || {};

  const configurations = mapAuctionConfigurations(rawConfigurations);
  const serviceCosts = mapAuctionServiceCosts(rawServiceCosts);
  const strategy = mapAuctionStrategy(rawStrategy);

  const rawPeriod = auctionTerm?.period;
  const period = rawPeriod ? mapPeriod(rawPeriod) : null;

  return {
    isEnabled: !!auctionTerm && !!isAvailable,
    currentOverServiceBet: defaultTo(0, overServiceBet),
    currentOverPackageBet: defaultTo(0, overPackageBet),
    minimalBet: minimalBet || 1,
    maximalBet: maximalBet || 99,
    incompatibleServices: (incompatibleServices as Array<string> as Array<EServiceType>) || [],
    configurations,
    serviceCosts,
    period,
    strategy,
    nextBets: [],
    previousBets: [],
  };
}
